import { useApiQuery } from "@/lib/query";
import { MAX_COMPARE, MIN_COMPARE } from "./selection";
import type { Comparison } from "./types";

const POLL_MS = 3000;

/**
 * One read for the whole page; it only fires for a valid selection. While a
 * re-score of `waitingOn` (evaluator keys) runs, it polls until those
 * evaluators' versions line up again.
 */
export const useComparison = (ids: string[], waitingOn: string[] = []) =>
  useApiQuery<Comparison>(
    "/compare",
    { ids: ids.join(",") },
    {
      enabled: ids.length >= MIN_COMPARE && ids.length <= MAX_COMPARE,
      refetchInterval: (query) =>
        query.state.data?.evaluators.some((e) => e.version_mismatch && waitingOn.includes(e.key))
          ? POLL_MS
          : false,
    },
  );
